export default class Service {

	static get $inject(){
		return [
			'$rootScope', '$q', '$timeout', '$state',
			'Notification',
			'ApiAccountService'];
	}


	constructor($rootScope, $q, $timeout, $state,
	            Notification,
	            ApiAccountService){

		this._$q = $q;
		this._$timeout = $timeout;
		this._$rootScope = $rootScope;
		this._$state = $state;

		this._Notification = Notification;
		this._ApiAccountService = ApiAccountService;
	}

	update(data){
		/*let deferred = this._$q.defer();return deferred.promise; */

		this._ApiAccountService.update(data)
			.then(result =>{
				this._showSuccess(result);
				this._$state.reload(true);
			})
			.catch(err =>{
				this._showError(err);
			});

	}

	changePassword(data){
		return this._ApiAccountService.changePassword(data);
	}


	// --- Private -----------------------------------------------------------------------------------------------------

	_showSuccess(result){
	}

	_showError(err){
	}
}

/*
 connect()
 {

 this._ApiRemoteService.connect({
 mac: this.panel.mac,
 remoteAccessPassword: this.panel.remoteAccessPassword,
 userCode: this.panel.userCode
 }).then(result =>{
 this._setConnectedStatus(true, false);
 }).catch(err =>{
 if( err && err.status === 400 ){
 return this.messages.connect = this._MessagesService.errors.remote.connect;
 }
 this.messages.remoteAccessPassword = this._MessagesService.errors.remote.remoteAccessPassword;
 this._setConnectedStatus(false, false);
 });
 }


 disconnect()
 {
 if( !this.connected ){ return; }
 this._ApiRemoteService.disconnect()
 .then((result)=>{
 this._setConnectedStatus(false, false);
 })
 .catch((err)=>{
 this._setConnectedStatus(false, false);
 });
 }*/



/** WEBPACK FOOTER **
 ** ./src/main/account/service.js
 **/